package top.wcpe.allincore.layout.engine

import kotlin.jvm.JvmField
import kotlin.jvm.JvmStatic

/**
 * 四向边距值（margin/padding 共用）。
 *
 * ADR-0034：保留「public final 字段 + 同名访问器」双形态（JVM 端 `@JvmField` 保字段直读，
 * 同名方法保 `top()` 式调用点），下游两种用法零改动。
 */
class Edges(
    @JvmField val top: Float,
    @JvmField val right: Float,
    @JvmField val bottom: Float,
    @JvmField val left: Float
) {

    fun top(): Float = top

    fun right(): Float = right

    fun bottom(): Float = bottom

    fun left(): Float = left

    override fun equals(other: Any?): Boolean {
        if (this === other) {
            return true
        }
        if (other !is Edges) {
            return false
        }
        // 逐位比较（等价 Java Float.compare == 0）：NaN 自反相等、+0f/-0f 不相等
        return top.toBits() == other.top.toBits() &&
            right.toBits() == other.right.toBits() &&
            bottom.toBits() == other.bottom.toBits() &&
            left.toBits() == other.left.toBits()
    }

    override fun hashCode(): Int {
        // 逐位复刻原 Java Objects.hash(top, right, bottom, left)
        var result = 1
        result = 31 * result + top.hashCode()
        result = 31 * result + right.hashCode()
        result = 31 * result + bottom.hashCode()
        result = 31 * result + left.hashCode()
        return result
    }

    override fun toString(): String {
        return "Edges[top=$top, right=$right, bottom=$bottom, left=$left]"
    }

    companion object {

        private val ZERO = Edges(0f, 0f, 0f, 0f)

        /** 四边相同。 */
        @JvmStatic
        fun all(v: Float): Edges {
            return Edges(v, v, v, v)
        }

        /** 水平 / 垂直 各一组：horizontal=左右，vertical=上下。 */
        @JvmStatic
        fun horizontal(horizontal: Float, vertical: Float): Edges {
            return Edges(vertical, horizontal, vertical, horizontal)
        }

        @JvmStatic
        fun zero(): Edges {
            return ZERO
        }
    }
}
